import { render, staticRenderFns } from "./view-template-modal.vue?vue&type=template&id=c4904c0e&scoped=true"
import script from "./view-template-modal.vue?vue&type=script&lang=js"
export * from "./view-template-modal.vue?vue&type=script&lang=js"
import style0 from "./view-template-modal.vue?vue&type=style&index=0&id=c4904c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4904c0e",
  null
  
)

export default component.exports